import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles"

const SectionTitleContainer = styled('div')<{ marginBottom?: string }>(({ marginBottom }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: marginBottom,
    '@media (max-width: 1024px)': {
        padding: '0 16px',
    }
}))

const SectionTitleStyled = styled(Typography<'h2'>)({
    color: '#00E378',
    fontSize: '48px',
    fontWeight: '800',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 1024px)': {
        fontSize: '32px',
    }
});

const SectionTitleSecondary = styled(Typography<'span'>)({
    color: '#F1F7F7',
    fontSize: '48px',
    fontWeight: '800',
    lineHeight: '54px',
    '@media (max-width: 1024px)': {
        fontSize: '32px',
        lineHeight: '36px',
    }
});

const SectionLogo = styled('img')({
    width: '64px',
    height: '64px',
    marginBottom: '24px',
    '@media (max-width: 1024px)': {
        width: '48px',
        height: '48px',
        marginBottom: '16px',
    }
});

const SectionDescription = styled(Typography<'p'>)<{ descriptionMarginTop?: string }>(({ descriptionMarginTop }) => ({
    color: '#F1F7F7',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '24px',
    marginTop: descriptionMarginTop,
    '@media (max-width: 1024px)': {
        fontSize: '14px',
        lineHeight: '20px',
    }
}));

interface SectionTitleProps {
    title: string;
    secondaryTitle?: string;
    logo?: string;
    description?: string;
    descriptionMarginTop?: string;
    marginBottom?: string;
}

export const SectionTitle = ({ title, secondaryTitle, logo, description, descriptionMarginTop = '12px', marginBottom = '55px' }: SectionTitleProps) => {
    return (
        <SectionTitleContainer marginBottom={marginBottom}>
            {logo && <SectionLogo src={logo} alt={title} />}

            <SectionTitleStyled component="h2">
                {title}
                {secondaryTitle && (

                    <SectionTitleSecondary component="span">{secondaryTitle}</SectionTitleSecondary>

                )}
            </SectionTitleStyled>
            {description && <SectionDescription component="p" descriptionMarginTop={descriptionMarginTop}>{description}</SectionDescription>}
        </SectionTitleContainer>
    )
}